export const FILE_SIZE_UNITS = ["B", "KB", "MB", "GB"];

export const FILE_SIZE_BASE = 1024;

export const EMPTY_ATTACHMENT_TEXT = "No file attached";

export const ATTACHMENTS_TITLE_TEXT = "Attachments";

export const ATTACH_FILES_TEXT = "Attach files";

export const READY_TO_UPLOAD_TEXT = "Ready to upload";

export const SAVED_FILE_TEXT = "Saved file";

export const REMOVAL_PENDING_TEXT = "Will be removed on save";

export const UNDO_REMOVAL_TEXT = "Undo";

export const PANEL_BASE_CLASS = "mt-3 bg-surface p-3 font-montserrat";

export const DEFAULT_PANEL_BORDER_CLASS = "border border-border";

export const HIGHLIGHTED_PANEL_BORDER_CLASS =
  "border-[2.3px] rounded-xl color-changing-border";

export const LAYOUT_CLASS =
  "flex flex-col md:flex-row md:items-center md:justify-between";

export const ATTACHMENT_LIST_CLASS = "mt-3 flex flex-col gap-2";

export const ATTACHMENT_ROW_CLASS =
  "flex items-center justify-between gap-3 rounded-md border border-border px-3 py-2";

export const ATTACHMENT_ROW_ACTIONS_CLASS = "flex shrink-0 items-center gap-2";

export const ENABLED_UPLOAD_CLASS =
  "bg-action-attach text-action-attach-text hover:bg-action-attach-hover";

export const DISABLED_UPLOAD_CLASS =
  "pointer-events-none bg-surface-muted text-text-muted";

export const UPLOAD_BUTTON_BASE_CLASS =
  "mt-4 inline-flex h-9 cursor-pointer items-center rounded-md px-3 text-sm font-semibold md:mt-0";

export const ICON_BUTTON_BASE_CLASS =
  "inline-flex h-8 w-8 items-center justify-center rounded-md";

export const SECONDARY_ICON_BUTTON_CLASS =
  "border border-border text-text hover:bg-surface-muted";

export const DOWNLOAD_BUTTON_CLASS =
  "bg-primary text-on-primary hover:bg-primary-hover";

export const REMOVE_SAVED_ATTACHMENT_BUTTON_CLASS =
  "bg-danger text-on-danger hover:bg-danger-hover";

export const UNDO_REMOVAL_BUTTON_CLASS =
  "inline-flex h-8 items-center rounded-md border border-border px-2 text-xs font-semibold text-text hover:bg-surface-muted";
